module.exports = __webpack_public_path__ + "static/media/pk-polygon.c4cae87e.png";